import { useState } from "react";
import { Link } from "react-router-dom";
import { LogIn, LogOut, User, Wallet, Heart } from "lucide-react";
import { useCustomer } from "@/lib/auth";

export default function UserMenu({ mobile = false }) {
  const { user, loading, login, logout } = useCustomer();
  const [open, setOpen] = useState(false);
  if (loading) return null;

  if (!user) {
    return (
      <button onClick={() => login(window.location.pathname === "/" ? "/account" : window.location.pathname)} data-testid={mobile ? "nav-mobile-signin-button" : "nav-signin-button"}
        className={`flex items-center justify-center gap-2 text-sm font-semibold rounded-full transition-colors whitespace-nowrap ${mobile ? "border border-ink/15 text-ink px-4 py-3" : "border border-ink/15 text-ink px-3.5 py-2.5 hover:bg-ink hover:text-sand"}`}>
        <LogIn size={15} /> {mobile ? "Sign in with Google" : "Sign in"}
      </button>
    );
  }

  const items = [
    { to: "/account", label: "My trips", icon: User, id: "trips" },
    { to: "/account?tab=wishlist", label: "Wishlist", icon: Heart, id: "wishlist" },
    { to: "/account?tab=earn", label: "Refer & earn", icon: Wallet, id: "earn" },
  ];

  if (mobile) {
    return (
      <div className="flex flex-col gap-3 border-t border-ink/10 pt-4" data-testid="nav-mobile-user-menu">
        {items.map((i) => <Link key={i.id} to={i.to} className="flex items-center gap-2 text-base font-medium text-ink" data-testid={`nav-mobile-user-${i.id}`}><i.icon size={16} /> {i.label}</Link>)}
        <button onClick={logout} className="flex items-center gap-2 text-sm text-ink/60" data-testid="nav-mobile-signout-button"><LogOut size={15} /> Sign out</button>
      </div>
    );
  }

  return (
    <div className="relative" onMouseLeave={() => setOpen(false)}>
      <button onClick={() => setOpen(!open)} data-testid="nav-user-menu-button" className="flex items-center gap-2 pl-1 pr-3 py-1 rounded-full border border-ink/15 hover:border-ink/40 transition-colors">
        {user.picture ? <img src={user.picture} alt="" className="w-8 h-8 rounded-full" referrerPolicy="no-referrer" /> : <span className="w-8 h-8 rounded-full bg-ink text-sand grid place-items-center text-xs font-bold">{user.name?.[0]}</span>}
        <span className="text-sm font-semibold text-ink max-w-[110px] truncate">{user.name?.split(" ")[0]}</span>
      </button>
      {open && (
        <div className="absolute right-0 top-full mt-2 w-52 bg-white border border-ink/10 rounded-2xl shadow-xl p-2 z-50" data-testid="nav-user-menu">
          {items.map((i) => (
            <Link key={i.id} to={i.to} onClick={() => setOpen(false)} data-testid={`nav-user-${i.id}`} className="flex items-center gap-2.5 px-3 py-2.5 rounded-xl text-sm text-ink hover:bg-sand transition-colors"><i.icon size={15} /> {i.label}</Link>
          ))}
          <button onClick={() => { setOpen(false); logout(); }} data-testid="nav-signout-button" className="w-full flex items-center gap-2.5 px-3 py-2.5 rounded-xl text-sm text-ink/60 hover:bg-sand hover:text-red-600 transition-colors"><LogOut size={15} /> Sign out</button>
        </div>
      )}
    </div>
  );
}
